import React from 'react';

import AGTable from 'components/shared/AGTable/AGTable';
import ErrorBoundary from 'components/shared/Error/Boundary';

const MedicationsTable = ({ data = [], onCellClicked = () => {}, getRowId = () => {} }) => {
  return (
    <ErrorBoundary>
      <div className="flex h-full flex-col overflow-hidden !pb-0">
        <div className="ag-theme-quartz flex-grow">
          <AGTable
            data={data}
            rowSelection="multiple"
            suppressRowClickSelection={true}
            customClassName="ag-grid-interactive"
            defaultColDef={{ flex: 1 }}
            onCellClicked={onCellClicked}
            getRowId={getRowId}
            suppressDragLeaveHidesColumns
          />
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default MedicationsTable;
